import React from "react"
import { withRouter } from "react-router-dom"
import { typesDrawings } from "../../variables"
import { Container, Image } from "react-bootstrap"
import styles from "./Drawings.module.scss"
import lampDraw from "./../../assets/drawingsImages/lamp.PNG"

const Drawings = () => {
    return (
        <div className="m-5 textSmall textFont">
            <p className="my-5">
                Każdy z typów można skonfigurować podając wymiary:
                <br/>
                <br/>
                <b>H</b> - wysokość środka kierownicy do środka blatu w mm,
                <br/>
                <b>L</b> - długość odsunięcia od kierownicy w mm,
                <br/>
                <b>W</b> - rozstaw mocowania na kierownicy w mm.
                <br/>
                <b>⍺</b> - kąt pochylenia w
                stopiniach.
            </p>
            {typesDrawings.map(type =>
                <Container fluid className={`${styles.imgContainer} mb-4`}>
                    <h3 className="title is-2 text-center">{type.label}</h3>
                    <Image
                        src={type.image.default}
                        key={type.title}
                        alt={type.title}
                        className={styles.img}/>
                </Container>
            )}
            <p className="my-5">
                <b>Dodatkowy uchwyt na lampkę </b>
                można dodać do każdego typu mapnika.
                <br/>
                Ma średnicę φ 30 mm i
                przeznaczony jest do wyższych mapników.
                <br/>
                Przestrzeń na umieszczenie uchwytu i lampki wynosi ok.
                60 mm.
            </p>
            <div className={styles.imgContainer}>
                <Image src={lampDraw} alt="lampDraw" className={styles.imgLamp}/>
            </div>
        </div>
    )
}

export default withRouter(Drawings)